// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetLkTypeModel, IMappers, TGetLkTypeResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetLkTypeResponseV2 } from '../../entities/get_lk_type_v2/GetLkTypeResponseV2';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetLkTypeModel(): TGetLkTypeModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'lk-type',
    pathApi: '/v2/get-lk-type/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IGetLkTypeOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetLkType<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetLkTypeOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetLkTypeResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetLkTypeModel(),
    config,
  )) as FetchResponse<TGetLkTypeResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetLkTypeResponseV2, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetLkTypeResponse>;
}
